export const ADMINISTRATOR = '101';
export const OPERATION = '102';
export const PROCESSING = '103';
export const ADMINISTRATOR_OPERATION = '101,102';
export const ADMINISTRATOR_OPERATION_PROCESSING = '101,102,103';
export const ADMINISTRATOR_PROCESSING = '101,103';
export const OPERATION_PROCESSING = '102,103';

